import theme from '../../theme';

const styles = {
  outerBox: {
    flexGrow: 1,
  },
  title: {
    color: theme.palette.common.black,
  },
  subtitle: {
    color: theme.palette.common.black,
    padding: '0 20px',
  },
  button: {
    marginTop: '15px',
  },
};

export default styles;
